import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BinaService } from '../../../services/bina/bina.service';

import { MatSnackBar } from '@angular/material';
import { ToastComponent } from '../../toast/toast.component';

export interface DialogData {}

@Component({
    selector: 'app-add-binas',
    templateUrl: './add-binas.component.html',
    styleUrls: ['./add-binas.component.scss']
})
export class AddBinasComponent implements OnInit {

    public phoneNumber = '';
    public loading = false;

    constructor(
        public dialogRef: MatDialogRef<AddBinasComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        public binaService: BinaService,
        private snackBar: MatSnackBar
    ) { }

    ngOnInit() {
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }



    save() {
        this.loading = true;
        this.binaService.add(this.phoneNumber).subscribe((res)=>{
            this.loading = false;
            if(res.success){
                this.snackBar.openFromComponent(ToastComponent, {
                    data: res.msg
                });
                this.dialogRef.close(res.id);
            }else{
                this.snackBar.openFromComponent(ToastComponent, {
                    data: res.msg
                });
            }
        })
    }
}
